/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function MergeRulesAllow({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M3.5.9a2.6 2.6 0 0 1 .6 5.127V6.5q0 .204.015.404a.6.6 0 0 1-.015.174v1.428c.22.002.431.125.534.337q.176.365.403.699a.598.598 0 0 1-.937.74V14.5a.6.6 0 1 1-1.2 0V6.027A2.598 2.598 0 0 1 3.5.9m9.363 12.952a.6.6 0 0 1 .31 1.16 2.6 2.6 0 0 1-1.346 0 .6.6 0 0 1 .31-1.16 1.4 1.4 0 0 0 .726 0m-2.14-2.45a.6.6 0 0 1 .425.735 1.4 1.4 0 0 0 0 .726.6.6 0 0 1-1.16.31 3 3 0 0 1-.038-.163.6.6 0 0 1-.307.09H9.5q-.249 0-.493-.018a.6.6 0 0 1 .089-1.197q.2.015.404.015h.143c.113 0 .217.034.307.09q.017-.083.038-.163a.6.6 0 0 1 .735-.425m3.554 0a.6.6 0 0 1 .735.425 2.6 2.6 0 0 1 0 1.346.6.6 0 0 1-1.16-.31 1.4 1.4 0 0 0 0-.726.6.6 0 0 1 .425-.735m-8.653-.283a.6.6 0 0 1 .834-.156q.334.227.7.403a.6.6 0 0 1-.522 1.081 6.6 6.6 0 0 1-.855-.494.6.6 0 0 1-.157-.834M12.5 9.9q.35 0 .673.088a.6.6 0 0 1-.31 1.16 1.4 1.4 0 0 0-.726 0 .6.6 0 0 1-.31-1.16q.324-.087.673-.088m-1-9.5a4.1 4.1 0 1 1 0 8.199A4.1 4.1 0 0 1 11.5.4m0 1.2a2.9 2.9 0 1 0 0 5.8 2.9 2.9 0 0 0 0-5.8m1.075 1.476a.6.6 0 0 1 .85.848l-1.994 2a.6.6 0 0 1-.863-.014L9.563 4.838a.6.6 0 0 1 .874-.82l.582.619zM3.5 2.1a1.4 1.4 0 1 0 0 2.8 1.4 1.4 0 0 0 0-2.8" /></svg>;
}
;